import { fail, success } from '@/helpers/result-helper'
import toast from '@/services/toasts/index'
import { isSuccess, isHttpStatus } from '@/helpers/http-status-helpers'
import { orderBy } from 'lodash'

const getDefaultState = () => {
  return {
    bookingContacts: [],
    loadingCount: 0,
    crudLoadingCount: 0,
    bookingContactsLoadingCount: 0,
    standardBookingDetailsLoadingCount: 0,
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    moduleName: () => 'contacts',
    bookingContacts: (state) => (locationId) => {
      const contacts = state.bookingContacts.find(
        (x) => x.locationId === locationId
      )

      return contacts ? orderBy(contacts.list, ['fullName'], ['asc']) : []
    },
    isLoading: (state) => state.loadingCount > 0,
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
    isLoadingBookingContacts: (state) => state.bookingContactsLoadingCount > 0,
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
    START_LOADING_BOOKING_CONTACTS(state) {
      state.bookingContactsLoadingCount++
    },
    FINISH_LOADING_BOOKING_CONTACTS(state) {
      state.bookingContactsLoadingCount--
    },
    SET_CLIENT_BOOKING_CONTACTS(state, payload) {
      const found = state.bookingContacts.find(
        (x) => x.locationId === payload.locationId
      )

      if (!found) {
        return state.bookingContacts.push({
          locationId: payload.locationId,
          list: payload.contacts,
        })
      }

      found.list = payload.contacts
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async loadBookingContacts({ commit, getters }, locationId) {
      // Check cached contacts
      const hasContacts = getters.bookingContacts(locationId)

      if (hasContacts && hasContacts.length > 0)
        return Promise.resolve(success(hasContacts))

      commit('START_LOADING_BOOKING_CONTACTS')

      try {
        const response = await this.$api.contacts.getBookingContacts(locationId)

        if (isSuccess(response.status)) {
          commit('SET_CLIENT_BOOKING_CONTACTS', {
            contacts: isHttpStatus(response.status, 204) ? [] : response.data,
            locationId,
          })
          return success(response.data)
        }
      } catch (ex) {
        toast.error('Cannot load booking contacts')
        return fail()
      } finally {
        commit('FINISH_LOADING_BOOKING_CONTACTS')
      }
    },
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
